import React from "react";
import propTypes from "prop-types";
import { useFormContext } from "./Form";
import { getId } from "./field";

const Label = ({ children, ...props }) => {
    const context = useFormContext();
    const id = getId("fieldset-legend", context);

    return (
        <context.LegendTag id={id} {...props}>
            { children }
        </context.LegendTag>
    );
};

Label.propTypes = {
    children: propTypes.any,
};

export default Label;
